import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

Alpine.plugin(collapse)

document.addEventListener('alpine:init', () => {
  
  // --- SHARE COMPONENT ---
  Alpine.data('shareComponent', (data) => ({
    copied: false,
    copyUrl(passedURL) {
      let url = passedURL ? passedURL : window.location.href;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => this.showCopied())
          .catch(() => this.fallbackCopy(url));
      } else {
        this.fallbackCopy(url);
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.showCopied();
      } catch (err) {
        alert('Copy failed. Please copy manually.');
      }
      document.body.removeChild(input);
    },
    showCopied() {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    }
  }));

  // --- MAP CORE LOGIC ---
  Alpine.data('map', () => ({
    activeRegion: null,
    isDesktop() {
      return window.innerWidth >= 640;
    },
    handleMouseEnter(code) {
      if (this.isDesktop()) {
        this.activeRegion = code;
      }
    },
    handleMouseLeave() {
      if (this.isDesktop()) {
        this.activeRegion = null;
      }
    },
    handleMobileFocus(event) {
      if (!this.isDesktop()) {
        this.activeRegion = event.detail.code;
      }
    }
  }));

  // --- GOOGLE MAP INITIALIZATION ---
  let map;
  
  function initMap() {
    const mapElement = document.getElementById('map');
    if (!mapElement) return; // Guard clause if map div doesn't exist on current page

    map = new google.maps.Map(mapElement, {
      zoom: 15,
      gestureHandling: 'greedy',
      scrollwheel: true,
      zoomControl: true,
      center: { lat: 51.5074, lng: 0.1278 } 
    });
    
    map.maxDefaultZoom = 15;
    window.dispatchEvent(new CustomEvent('map-ready'));

    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
      this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
    });
  }

  // Safe initiation check for Google Maps
  if (typeof google !== 'undefined' && google.maps) {
    initMap();
  } else {
    // If Google Maps API loads asynchronously, listen for its load event or handle gracefully
    window.initMap = initMap; 
  }

  // --- MAP MARKERS POPULATION ---
  window.populateMap = () => {
    return {
      markers: {},
      initMarkers() {
        if (typeof google !== 'undefined' && map) {
          map.markers = [];
          const markers = document.getElementsByClassName("marker");
          for (let i = 0; i < markers.length; i++) {
            const m = markers[i];
            this.addMarker(
              m.getAttribute('data-lat'), 
              m.getAttribute('data-lng'), 
              m.getAttribute('data-name'), 
              m.getAttribute('data-url'), 
              m.getAttribute('data-type'), 
              m.getAttribute('data-location'), 
              m.getAttribute('data-id'),
              m.getAttribute('data-excerpt'), 
              m.getAttribute('data-logo')    
            );
          }
          this.centerMap(markers);
        }
      },

      addMarker(lat, lng, name, url, type, location, id, excerpt, logo) {
        const latLng = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };

        const marker = new google.maps.Marker({
          position: latLng,
          map: map,
          label: {
            color: "#fff",
            fontSize: "12px",
            fontWeight: "bold"
          },
        });

        if (!map.markers) map.markers = [];
        map.markers.push(marker);

        google.maps.event.addListener(marker, 'click', function() {
          window.dispatchEvent(new CustomEvent('open-org-modal', {
            detail: {
              title: name,
              excerpt: excerpt,
              website: url,
              logo: logo
            }
          }));
        });
      },

      centerMap(markers) {
        if (!markers.length) return;
        const bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < markers.length; i++) {
          bounds.extend({
            lat: parseFloat(markers[i].getAttribute('data-lat')),
            lng: parseFloat(markers[i].getAttribute('data-lng'))
          });
        }
        map.fitBounds(bounds);
      }
    }
  };

  // --- GEOLOCATION DISTANCE SEARCH ---
  Alpine.data('organisationDinstanceSearch', (data) => ({
    postcode: '',
    search: '',
    distance: '25',
    finding_location: false,
    submit() {
      if(this.postcode){
        const postcode = this.postcode + " UK";
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+encodeURIComponent(postcode)+'&key=AIzaSyCdQKFtxYH5-1-ZJtA8Bpr4HkOFhEmAKro')
          .then(res => res.json())
          .then(data => {
            if (data.results && data.results[0]) {
              const lat = data.results[0].geometry.location.lat;
              const lng = data.results[0].geometry.location.lng;
              
              let searchURL = '/find-support?type=organisation';
              if (lat) {
                searchURL += `&lat=${lat}&lng=${lng}&postcode=${encodeURIComponent(this.postcode)}&distance=${this.distance}`;
              }
              if (this.search) {
                searchURL += '&search=' + encodeURIComponent(this.search);
              }
              window.location.replace(searchURL + '#organisations');
            }
          });
        } else {
          let searchURL = '/find-support?type=organisation';
              
              if (this.search) {
                searchURL += '&search=' + encodeURIComponent(this.search);
              }
              window.location.replace(searchURL + '#organisations');
        }
    },
    userLocationSearch() {
      this.finding_location = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          window.location.replace(`/find-support?lat=${lat}&lng=${lng}&postcode=${encodeURIComponent(this.postcode)}&distance=${this.distance}&type=organisation#organisations`);
        },
        () => {
          this.finding_location = false;
          console.log("Your browser doesn't support Geolocation or permission was denied");
        }
      );
    }
  }));

  // --- DONATE WIDGET COMPONENT (FIXED AND MAPPED TO YOUR TWIG VARIABLES) ---
  Alpine.data('donateWidget', (data) => ({
    selected: data.selected || 'monthly',
    
    // Explicitly declaring formData structure matching your template's x-model targets
    formData: {
      once_amount: data.once_amount || '100',
      monthly_amount: data.monthly_amount || '100',
      other_amount: '' 
    },
    
    once_url: data.once_url_base || '',
    regular_url: data.regular_url_base || '',

    giveMonthly() {
      const amount = this.formData.other_amount || this.formData.monthly_amount;
      if (!amount) return alert('Please choose or enter an amount');
      window.location.href = `${this.regular_url}?recurring=1&amount=${encodeURIComponent(amount)}`;
    },

    giveOnce() {
      const amount = this.formData.other_amount || this.formData.once_amount;
      if (!amount) return alert('Please choose or enter an amount');
      window.location.href = `${this.once_url}?amount=${encodeURIComponent(amount)}`;
    },
    
    submit() {
      if (this.selected === 'monthly') {
        this.giveMonthly();
      } else {
        this.giveOnce();
      }
    }
  }));

});

// --- INITIALIZE ALPINE ---
window.Alpine = Alpine;
Alpine.start();